import React from 'react'

/**
 * Champ dont l'affichage suit le mode d'édition du formulaire : en lecture seule, seuls les champs
 * qui portent une valeur sont affichés. `ui:options.disabledBy` nomme une autre propriété
 * booléenne du formulaire qui, quand elle est vraie, rend ce champ sans objet : il est alors grisé.
 * `ui:options.shownBy` nomme à l'inverse la propriété booléenne dont ce champ précise le sens : il
 * n'est affiché que quand elle est vraie (une sous-option, que la classe `form-sub-option` décale).
 * Les valeurs qui commandent sont lues dans les données du formulaire, exposées par le contexte.
 * Deux rendus, selon le type déclaré : case à cocher pour un booléen, saisie texte sinon.
 */
export const ConditionalField = ({ schema, uiSchema, idSchema, formData, formContext, onChange, disabled }) => {
  const { disabledBy, shownBy } = uiSchema?.['ui:options'] || {}
  if (disabled && !formData) return null
  if (shownBy && !formContext?.formData?.[shownBy]) return null

  const isDisabled = disabled || !!(disabledBy && formContext?.formData?.[disabledBy])

  if (schema.type === 'boolean') {
    return (
      <div className={`checkbox${isDisabled ? ' disabled' : ''}`}>
        <label>
          <input
            type="checkbox"
            id={idSchema?.$id}
            checked={!!formData}
            disabled={isDisabled}
            onChange={event => onChange(event.target.checked)}
          />
          <span>{schema.title}</span>
        </label>
      </div>
    )
  }

  return (
    <div className="form-group">
      <label className="control-label" htmlFor={idSchema?.$id}>
        {schema.title}
      </label>
      <input
        id={idSchema?.$id}
        type="text"
        className="form-control"
        value={formData || ''}
        disabled={isDisabled}
        onChange={event => onChange(event.target.value)}
      />
    </div>
  )
}
